module.exports = __webpack_public_path__ + "src/assets/img/ic06.d36a5e7e.svg";